// Delivery methods
import PudoIcon from '../icons/icon_pudo.png';
import HomeIcon from '../icons/icon_home.png';
// Delivery types
import StandardDeliveryIcon from '../icons/icon_standard.png';
import FastDeliveryIcon from '../icons/icon_fast.png';
import ExpressDeliveryIcon from '../icons/icon_express.png';

interface CarrierIconsProps {
    DeliveryMethod: string;
    DeliveryType: string;    
  }

export const getCarrierIcons = (opt: CarrierIconsProps) => {
    const methodIcon = opt?.DeliveryMethod.toLowerCase() === 'pudo' ? PudoIcon : HomeIcon;
    let typeIcon = StandardDeliveryIcon;
    if (opt?.DeliveryType?.toLowerCase() === 'fast') typeIcon = FastDeliveryIcon;
    if (opt?.DeliveryType?.toLowerCase() === 'express') typeIcon = ExpressDeliveryIcon;
    return { methodIcon, typeIcon };
  };  